import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';

import { SlipType } from '../../slip-type';
import { BetslipStateInput } from '../base-input-builder';

export function getSystemBetStake(
    betslipState: Omit<BetslipStateInput, 'rewardTokensState'>,
    system: SlipType | null = betslipState.types.systemBet.systemInfo,
): number | null {
    if (betslipState.base.displayMode !== BetslipDisplayMode.Linear || !system) {
        return betslipState.types.systemBet.stake;
    }

    const typeStakes = betslipState.types.systemBet.linearTypeStakes ?? {};

    return typeStakes[system.key]?.stake ?? null;
}
